var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 10.5H12.1667C11.25 10.5 10.5 11.25 10.5 12.1667V23.8333C10.5 24.75 11.25 25.5 12.1667 25.5H23.8333C24.75 25.5 25.5 24.75 25.5 23.8333V12.1667C25.5 11.25 24.75 10.5 23.8333 10.5ZM15.9167 17.5833C15.9167 18.25 15.3333 18.8333 14.6667 18.8333H13.8333V20.5H12.5833V15.5H14.6667C15.3333 15.5 15.9167 16.0833 15.9167 16.75V17.5833ZM20.0833 19.25C20.0833 19.9167 19.5 20.5 18.8333 20.5H16.75V15.5H18.8333C19.5 15.5 20.0833 16.0833 20.0833 16.75V19.25ZM23.4167 16.75H22.1667V17.5833H23.4167V18.8333H22.1667V20.5H20.9167V15.5H23.4167V16.75ZM18 16.75H18.8333V19.25H18V16.75ZM13.8333 16.75H14.6667V17.5833H13.8333V16.75Z",
    fill: "#28519E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/DownloadPDF.a245e58b950a9e4286e4582fea9cd747.svg";
export { ForwardRef as ReactComponent };